<template>
  <div>
    <div>
      <input
        type="text"
        v-model="ticket"
        @input="checkTicket(ticket)"
        @keypress.enter.prevent
        placeholder="請輸入Jira ticket(必填)"
      />
      <span style="padding-left: 10px; color: red">{{ ticketErrorMsg }}</span>
    </div>
    <div class="addTable">
      <textarea
        type="text"
        v-model="key"
        @keypress.enter.prevent
        placeholder="請輸入KEY值(必填)"
      />
      <textarea
        v-for="lang in langs"
        :key="lang"
        type="text"
        v-model="langValues[lang]"
        @keypress.enter.prevent
        :placeholder="`請輸入${langsMapping[lang]}`"
      />
      <!--        <div v-if="isKeyRepeat" class="error">KEY值重複</div>-->
      <div v-if="!isKeyLegal" class="error">
        <div
          v-for="(item, key) in errorCode"
          v-bind:key="key"
          class="errorCode"
        >
          {{ item }}
        </div>
      </div>
      <button
        @click="handleClick"
        :disabled="
          key.trim() === '' ||
          langValues['zh_CN'].trim() === '' ||
          !isTicketValid ||
          env !== 'DEV'
        "
      >
        新增
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { regexRull, regex } from '@/utils/regex'
import { validateKeysForProject, VALIDATION_TOAST_MS } from '@/utils/key-guard'
export default {
  name: 'AddTable',
  components: {},
  data() {
    return {
      ticket: '',
      key: '',
      langValues: {},
      errorCode: {},
      ticketErrorMsg: '',
      isKeyLegal: true,
      isTicketValid: false,
    }
  },
  created() {
    this.langs.forEach((lang) => {
      this.$set(this.langValues, lang, '')
    })
  },
  computed: {
    ...mapGetters(['data', 'isLoading', 'langs', 'langsMapping', 'env', 'project']),
  },
  methods: {
    handleClick() {
      const body = {
        ticket: this.ticket.trim(),
        key: this.key.trim(),
      }

      const guardMsg = validateKeysForProject(
        this.project,
        [body.key],
        this.data.map((item) => item.key),
      )
      if (guardMsg) {
        this.$store.dispatch('handleMessage', {
          success: false,
          text: guardMsg,
          durationMs: VALIDATION_TOAST_MS,
        })
        return
      }

      for (const lang of this.langs) {
        const val = this.langValues[lang].trim()
        if (val !== '') {
          body[lang] = val
        }
      }

      this.$store.dispatch('addData', { body }).then((result) => {
        if (result) {
          this.ticket = ''
          this.key = ''
          this.langs.forEach((lang) => {
            this.$set(this.langValues, lang, '')
          })
          this.errorCode = {}
          this.isKeyLegal = true
        }
      })
    },

    checkTicket(ticket) {
      this.isTicketValid = /^[A-Za-z]{2,3}-\d{1,10}$/.test(ticket)
      this.ticketErrorMsg = !this.isTicketValid ? '單號格式錯誤' : ''
    },
    checkKeyLegal(lang) {
      //檢測是否有全形符號
      let fullWidthCheck = regex(regexRull.fullWidth, this.langValues[lang])
      if (fullWidthCheck) {
        fullWidthCheck = fullWidthCheck.join(' ')
        this.errorCode[lang] = `${lang} 存在全形 : ${fullWidthCheck}`
        this.isKeyLegal = false
      } else {
        delete this.errorCode[lang]
        if (Object.keys(this.errorCode).length == 0) this.isKeyLegal = true
        else this.isKeyLegal = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.addTable {
  width: 100%;
  margin: 1rem 0;
  display: flex;
  flex-wrap: wrap;
  input,
  textarea {
    width: 100%;
    height: 40px;
    padding: 5px;
    flex-shrink: 0;
    margin: 0.25rem 0;
    @media screen and (min-width: 768px) {
      width: calc(100% / 13);
      height: 60px;
      padding: 2px;
    }
  }
}

.error {
  width: 100%;
  color: red;
}

.errorCode {
  margin: 7px 0px;
}
</style>
